module.exports = __webpack_public_path__ + "img/logo_placeholder.afc546f1.png";